import React, { useEffect, useState, useRef } from 'react';
import { Link, useParams, useNavigate } from "react-router-dom";
import './account.css';
import axios from 'axios';
import { QRCodeSVG } from 'qrcode.react';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import { FaWhatsapp, FaFacebook, FaEnvelope } from 'react-icons/fa';
import { useAuth } from "../section-components/AuthContext";

const MyAccount = () => {
  const { agentId } = useParams();
  const navigate = useNavigate();
  const { agent, setAgent, login, logout } = useAuth();
  const [properties, setProperties] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const qrRef = useRef(null);
  const [currentProperty, setCurrentProperty] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  
  const [qrUrl] = useState(`https://keurgui.sn/#/agent-properties/${agentId}`);

  // State for agent profile form
  const [formData, setFormData] = useState({
    agentName: "",
    email: "",
    phoneNumber: "",
    adresse: "",
    presentation: "",
    infosSupplementaires: "",
    currentPassword: "",
    newPassword: "",
    confirmNewPassword: "",
  });
  
  // State for property creation form
  const [propertyFormData, setPropertyFormData] = useState({
    title: "",
    price: "",
    transactionType: "sale",
    productType: "appartement",
    propertyCategory: "residential",
    status: "available",
    coduStatus: "",
    address: "",
    city: "",
    coordinates: {
      latitude: "",
      longitude: "",
    },
    features: {
      bedrooms: 0,
      bathrooms: 0,
      parkingSpaces: 0,
      garages: 0,
      area: 0,
      hasPool: false,
      isWheelchairAccessible: false,
      isWaterfront: false,
      hasNavigableWater: false,
      allowsPets: false,
      allowsSmoking: false,
    },
    images: [],
    buildingDetails: {
      yearBuilt: "",
      isNewConstruction: false,
      isHistorical: false,
      structureType: [],
    },
    isVirtualTourAvailable: false,
    isOpenHouse: false,
    lotSize: 0,
    description: "",
    moveInDate: "",
    isForeclosure: false,
    agent: "",
  });

  // ============================================
  // FONCTIONS DE RAFRAÎCHISSEMENT
  // ============================================
  const refreshProperties = async () => {
    try {
      console.log("🔄 Rafraîchissement des propriétés...");
      const response = await axios.get(`https://keurgui-backend-kjour.ondigitalocean.app/api/products/agent/${agentId}`);
      console.log("✅ Propriétés reçues:", response.data);
      setProperties(response.data.products || []);
    } catch (err) {
      console.error("❌ Erreur lors du rafraîchissement:", err);
    }
  };

  // ============================================
  // FONCTION DE RÉINITIALISATION DU FORMULAIRE
  // ============================================
  const resetPropertyForm = () => {
    setPropertyFormData({
      title: "",
      price: "",
      transactionType: "sale",
      productType: "Maison unifamiliale",
      propertyCategory: "residential",
      status: "available",
      coduStatus: "",
      address: "",
      city: "",
      coordinates: { latitude: "", longitude: "" },
      features: {
        bedrooms: 0,
        bathrooms: 0,
        parkingSpaces: 0,
        garages: 0,
        area: 0,
        hasPool: false,
        isWheelchairAccessible: false,
        isWaterfront: false,
        hasNavigableWater: false,
        allowsPets: false,
        allowsSmoking: false,
      },
      images: [],
      buildingDetails: {
        yearBuilt: "",
        isNewConstruction: false,
        isHistorical: false,
        structureType: [],
      },
      isVirtualTourAvailable: false,
      isOpenHouse: false,
      lotSize: 0,
      description: "",
      moveInDate: "",
      isForeclosure: false,
      agent: "",
    });
  };

  // ============================================
  // FONCTION D'AJOUT DE PROPRIÉTÉ CORRIGÉE
  // ============================================
 
  // Récupérer agent et propriétés au chargement
  useEffect(() => {
    const fetchAgentData = async () => {
      try {
        console.log("📥 Récupération des données pour l'agent:", agentId);
        
        // Récupérer les infos de l'agent
        const agentResponse = await axios.get(`https://keurgui-backend-kjour.ondigitalocean.app/api/agents/${agentId}`);
        console.log("✅ Agent reçu:", agentResponse.data);

        if (typeof setAgent === "function") {
          setAgent(agentResponse.data);
        }

        // Récupérer les propriétés de l'agent
        await refreshProperties();
        
        setLoading(false);
      } catch (err) {
        console.error("❌ Erreur:", err);
        setError(err.message);
        setLoading(false);
      }
    };
    
    if (agentId) {
      fetchAgentData();
    }
  }, [agentId]);

  // Initialiser le formulaire agent quand les données sont chargées
  useEffect(() => {
    if (agent) {
      setFormData({
        agentName: agent.agentName || "",
        email: agent.email || "",
        phoneNumber: agent.phoneNumber || "",
        adresse: agent.adresse || "",
        presentation: agent.presentation || "",
        infosSupplementaires: agent.infosSupplementaires || "",
        currentPassword: "",
        newPassword: "",
        confirmNewPassword: "",
      });
    }
  }, [agent]);

  // Suppression propriété
  const handleDelete = async (productId) => {
    if (!window.confirm("Voulez-vous vraiment supprimer cette propriété ?")) return;
    try {
      const response = await axios.delete(`https://keurgui-backend-kjour.ondigitalocean.app/api/products/${productId}`);
      if (response.status === 200) {
        setProperties(prev => prev.filter(property => property._id !== productId));
        setSuccess("Propriété supprimée avec succès");
      }
    } catch (error) {
      setError("Erreur lors de la suppression.");
      console.error(error);
    }
  };
// Dans votre composant MyAccount.js

const handleAddProperty = async (e) => {
  e.preventDefault(); // Empêche le rechargement de la page
  
  setError("");
  setSuccess("");
  setIsLoading(true);
  
  try {
    console.log("=".repeat(50));
    console.log("🚀 DÉBUT DE L'AJOUT DE PROPRIÉTÉ");
    
    // Vérification que l'agent est connecté
    if (!agent || !agent._id) {
      throw new Error("Agent non connecté ou ID manquant");
    }

    // Préparation des données
    const propertyData = {
      ...propertyFormData,
      agent: agent._id,
      role: "agent",
      price: Number(propertyFormData.price),
      lotSize: Number(propertyFormData.lotSize || 0),
      features: {
        ...propertyFormData.features,
        bedrooms: Number(propertyFormData.features.bedrooms || 0),
        bathrooms: Number(propertyFormData.features.bathrooms || 0),
        parkingSpaces: Number(propertyFormData.features.parkingSpaces || 0),
        garages: Number(propertyFormData.features.garages || 0),
        area: Number(propertyFormData.features.area || 0),
      }
    };

    console.log("📦 Données préparées:", propertyData);

    // Envoi de la requête
    const response = await axios.post(
      "https://keurgui-backend-kjour.ondigitalocean.app/api/productss", 
      propertyData
    );
    
    console.log("✅ Réponse reçue:", response.data);
    
    if (response.status === 201 || response.status === 200) {
      setSuccess("✅ Propriété ajoutée avec succès !");
      
      // ✅ Réinitialiser le formulaire MAIS RESTER SUR LA PAGE
      resetPropertyForm();
      
      // ✅ Rafraîchir la liste des propriétés
      await refreshProperties();
      
      // ✅ Optionnel: Basculer vers l'onglet "Mes propriétés"
      const propertiesTab = document.querySelector('[href="#ltn_tab_1_5"]');
      if (propertiesTab) {
        propertiesTab.click();
      }
      
      // ✅ PAS DE REDIRECTION - on reste sur my-account
      console.log("✅ Propriété ajoutée, on reste sur la page");
    }
    
  } catch (err) {
    console.log("=".repeat(50));
    console.log("❌ ERREUR MAIS ON RESTE SUR LA PAGE:");
    console.log(err);
    
    // ✅ Gestion des erreurs SANS REDIRECTION
    let errorMessage = "";
    
    if (err.code === 'ECONNREFUSED') {
      errorMessage = "Impossible de se connecter au serveur. Vérifiez que le backend est lancé.";
    } else if (err.response) {
      // La requête a été faite et le serveur a répondu avec une erreur
      console.log("Status erreur:", err.response.status);
      console.log("Données erreur:", err.response.data);
      
      errorMessage = err.response.data?.message || 
                     err.response.data?.error || 
                     "Erreur lors de l'ajout de la propriété";
    } else if (err.request) {
      // La requête a été faite mais pas de réponse
      errorMessage = "Le serveur ne répond pas. Vérifiez votre connexion.";
    } else {
      // Erreur lors de la configuration
      errorMessage = err.message;
    }
    
    // ✅ Afficher l'erreur DANS LA PAGE (pas de redirection)
    setError(errorMessage);
    
    // ✅ SCROLL VERS LE HAUT POUR VOIR L'ERREUR
    window.scrollTo({ top: 0, behavior: 'smooth' });
    
  } finally {
    setIsLoading(false);
  }
};
  // Handlers pour les formulaires
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handlePropertyChange = (e) => {
    const { name, value } = e.target;
    setPropertyFormData({ ...propertyFormData, [name]: value });
  };

  const handleCoordinatesChange = (e) => {
    const { name, value } = e.target;
    setPropertyFormData({
      ...propertyFormData,
      coordinates: {
        ...propertyFormData.coordinates,
        [name]: value
      }
    });
  };

  const handleNestedChange = (e, parent) => {
    const { name, value, type, checked } = e.target;
    const newValue = type === 'checkbox' ? checked : value;
    
    setPropertyFormData({
      ...propertyFormData,
      [parent]: {
        ...propertyFormData[parent],
        [name]: newValue
      }
    });
  };

// ============================================
// FONCTION D'UPLOAD D'IMAGES (adaptée du premier code)
// ============================================
// Vérifiez que votre fonction ressemble à ceci
const handleLocalUpload = async (e) => {
  const file = e.target.files[0];
  if (!file) return;

  // Vérification que c'est bien une image
  if (!file.type.startsWith('image/')) {
    alert('Veuillez sélectionner une image valide');
    return;
  }

  const formDataFile = new FormData();
  formDataFile.append('image', file);

  try {
    const res = await axios.post('https://keurgui-backend-kjour.ondigitalocean.app/api/upload', formDataFile, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });

    console.log("Réponse upload:", res.data);

    // L'URL peut être dans différents formats selon le backend
    let imageUrl = res.data.imageUrl || res.data.url || res.data.path || res.data;
    
    // Construire l'URL complète
    const fullImageUrl = imageUrl.startsWith('http') 
      ? imageUrl 
      : `https://keurgui-backend-kjour.ondigitalocean.app${imageUrl.startsWith('/') ? '' : '/'}${imageUrl}`;

    setPropertyFormData((prev) => ({
      ...prev,
      images: [...prev.images, fullImageUrl]
    }));

    e.target.value = null;

  } catch (err) {
    console.error('Erreur d’upload :', err);
    alert('Upload échoué: ' + (err.response?.data?.message || err.message));
  }
};
// Ajoutez cette fonction dans votre composant
const getFullImageUrl = (imageUrl) => {
  if (!imageUrl) return '';
  
  // Si l'URL commence déjà par http, on la garde telle quelle
  if (imageUrl.startsWith('http')) {
    return imageUrl;
  }
  
  // Si l'URL commence par /uploads, on ajoute le domaine
  if (imageUrl.startsWith('/uploads')) {
    return `https://keurgui-backend-kjour.ondigitalocean.app${imageUrl}`;
  }
  
  // Si c'est juste un nom de fichier
  return `https://keurgui-backend-kjour.ondigitalocean.app/uploads/${imageUrl}`;
};

// ============================================
// FONCTION POUR SUPPRIMER UNE IMAGE
// ============================================
const handleRemoveImage = (index) => {
  setPropertyFormData((prev) => ({
    ...prev,
    images: prev.images.filter((_, i) => i !== index)
  }));
};

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    
    if (formData.newPassword !== formData.confirmNewPassword) {
      setError("Les nouveaux mots de passe ne correspondent pas.");
      return;
    }
    
    try {
      const response = await axios.put("https://keurgui-backend-kjour.ondigitalocean.app/api/update-agent", { 
        ...formData, 
        agentId: agent._id 
      });
      
      if (response.status === 200) {
        setSuccess("Profil mis à jour avec succès !");
        if (response.data.agent) {
          login(response.data.agent);
        }
      }
    } catch (err) {
      setError("Une erreur réseau s'est produite.");
    }
  };

  // Télécharger image QR
  const downloadImage = async () => {
    try {
      const canvas = await html2canvas(qrRef.current);
      const image = canvas.toDataURL('image/png');
      const link = document.createElement('a');
      link.href = image;
      link.download = 'qrcode-propriete.png';
      link.click();
    } catch (err) {
      console.error(err);
    }
  };

  const downloadPDF = async () => {
    try {
      const canvas = await html2canvas(qrRef.current);
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF();
      pdf.addImage(imgData, 'PNG', 20, 20, 170, 170);
      pdf.save('qrcode-propriete.pdf');
    } catch (err) {
      console.error(err);
    }
  };

  if (loading) return <p>Chargement...</p>;
  if (error) return <p style={{ textAlign: "center", color: "red" }}>Erreur: {error}</p>;
  if (!agent) return <div>Agent non trouvé</div>;

  return (
    <div className="liton__wishlist-area pb-70">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="ltn__product-tab-area">
              <div className="container">
                <div className="row">
                  <div className="col-lg-4">
                    <div className="ltn__tab-menu-list mb-50">
                      <div className="nav">
                        <a className="active show" data-bs-toggle="tab" href="#ltn_tab_1_1">
                          Tableau de bord <i className="fas fa-home" />
                        </a>
                        <a data-bs-toggle="tab" href="#ltn_tab_1_2">
                          Profils <i className="fas fa-user" />
                        </a>
                        <a data-bs-toggle="tab" href="#ltn_tab_1_4">
                          Détails du compte <i className="fas fa-user" />
                        </a>
                        <a data-bs-toggle="tab" href="#ltn_tab_1_5">
                          Mes propriétés <i className="fa-solid fa-list" />
                        </a>
                        <a data-bs-toggle="tab" href="#ltn_tab_1_6">
                          Ajouter une propriété <i className="fa-solid fa-plus" />
                        </a>
                        <a data-bs-toggle="tab" href="#ltn_tab_1_3">
                          Code QR <i className="fas fa-qrcode" />
                        </a>
                        <a onClick={() => {
                          logout();
                          navigate('/');
                        }}>
                          Déconnexion <i className="fas fa-sign-out-alt" />
                        </a>
                      </div>
                    </div>
                  </div>
                  
                  <div className="col-lg-8">
                    <div className="tab-content">
                      {/* Dashboard */}
                      <div className="tab-pane fade active show" id="ltn_tab_1_1">
                        <div className="ltn__myaccount-tab-content-inner">
                          <p>
                            Bonjour <strong>{agent.agentName}</strong> 👋  
                          </p>
                          <p>
                            Depuis votre tableau de bord, vous pouvez : voir toutes vos propriétés, 
                            modifier les détails de vos biens, supprimer une propriété, 
                            télécharger votre QR Code professionnel
                          </p>
                        </div>
                      </div>
                      
                      {/* Profile */}
                      <div className="tab-pane fade" id="ltn_tab_1_2">
                        <div className="ltn__myaccount-tab-content-inner">
                          <div className="ltn__comment-area mb-50">
                            <div className="ltn-author-introducing clearfix">
                              <div className="author-img">
                                <img
                                  src={
                                    agent?.photoProfil
                                      ? agent.photoProfil.startsWith('/uploads/')
                                        ? `https://keurgui-backend-kjour.ondigitalocean.app${agent.photoProfil}`
                                        : `https://keurgui-backend-kjour.ondigitalocean.app/uploads/${agent.photoProfil}`
                                      : "assets/img/blog/author.jpg"
                                  }
                                  alt="Photo de l'agent"
                                  onError={e => { e.target.src = "assets/img/blog/author.jpg"; }}
                                />
                              </div>
                              <div className="author-info">
                                <h6>Agent Immobilier</h6>
                                <h2>{agent.agentName}</h2>
                                <div className="footer-address">
                                  <ul>
                                    <li>
                                      <div className="footer-address-icon"><i className="icon-placeholder" /></div>
                                      <div className="footer-address-info">
                                        <p>{agent.territoire || "Localisation non définie"}</p>
                                      </div>
                                    </li>
                                    <li>
                                      <div className="footer-address-icon"><i className="icon-call" /></div>
                                      <div className="footer-address-info">
                                        <p><a href={`tel:${agent.phoneNumber}`}>{agent.phoneNumber}</a></p>
                                      </div>
                                    </li>
                                    <li>
                                      <div className="footer-address-icon"><i className="icon-mail" /></div>
                                      <div className="footer-address-info">
                                        <p><a href={`mailto:${agent.email}`}>{agent.email}</a></p>
                                      </div>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      
                      {/* QR Code */}
                      <div className="tab-pane fade" id="ltn_tab_1_3">
                        <div className="container d-flex justify-content-center">
                          <div className="rounded-4 border p-4" style={{ background: '#fefbe9', maxWidth: 900 }}>
                            <div className="row align-items-center g-4">
                              <div className="col-12 col-md-6 d-flex justify-content-center">
                                <div className="bg-white p-3 rounded-3" ref={qrRef}>
                                  <QRCodeSVG value={qrUrl} size={260} level="H" includeMargin={true} />
                                </div>
                              </div>
                              <div className="col-12 col-md-6 d-flex flex-column align-items-center align-items-md-start">
                                <h2 className="fw-bold mb-2 text-dark text-center text-md-start">
                                  Partagez votre QR Code
                                </h2>
                                <p className="mb-4 text-dark fs-5 text-center text-md-start">
                                  Téléchargez ce QR Code pour vos supports marketing.                                
                                </p>
                                <div className="w-100 mb-4" style={{ maxWidth: 340 }}>
                                  <button 
                                    className="btn btn-success w-100 mb-3 fs-5 fw-semibold"
                                    style={{ background: '#15cf7b', border: 'none' }}
                                    onClick={downloadPDF}
                                  >
                                    Télécharger PDF
                                  </button>
                                  <button 
                                    className="btn btn-primary w-100 fs-5 fw-semibold"
                                    style={{ background: '#0a7cff', border: 'none' }}
                                    onClick={downloadImage}
                                  >
                                    Télécharger l'image
                                  </button>
                                </div>
                                <div className="d-flex gap-4 mt-3 justify-content-center justify-content-md-start w-100 fs-2">
                                  <a href={`https://wa.me/?text=${encodeURIComponent(`Découvrez cet agent : ${qrUrl}`)}`}
                                    target="_blank" rel="noopener noreferrer" className="text-success">
                                    <FaWhatsapp />
                                  </a>
                                  <a href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(qrUrl)}`}
                                    target="_blank" rel="noopener noreferrer" className="text-primary">
                                    <FaFacebook />
                                  </a>
                                  <a href={`mailto:?subject=Agent immobilier&body=Voici le lien vers l'agent : ${qrUrl}`}
                                    className="text-danger">
                                    <FaEnvelope />
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      
                      {/* Account Details */}
                      <div className="tab-pane fade" id="ltn_tab_1_4">
                        <div className="ltn__myaccount-tab-content-inner">
                          <div className="ltn__form-box">
                            <form onSubmit={handleSubmit}>
                              <div className="row mb-50">
                                <div className="col-md-6">
                                  <label>Nom:</label>
                                  <input 
                                    type="text" 
                                    name="agentName" 
                                    value={formData.agentName} 
                                    onChange={handleChange} 
                                    className="form-control"
                                  />
                                </div>
                                <div className="col-md-6">
                                  <label>Email:</label>
                                  <input 
                                    type="email" 
                                    name="email" 
                                    value={formData.email} 
                                    onChange={handleChange} 
                                    className="form-control"
                                  />
                                </div>
                                <div className="col-md-6">
                                  <label>Téléphone:</label>
                                  <input 
                                    type="text" 
                                    name="phoneNumber" 
                                    value={formData.phoneNumber} 
                                    onChange={handleChange} 
                                    className="form-control"
                                  />
                                </div>
                                <div className="col-md-6">
                                  <label>Adresse:</label>
                                  <input 
                                    type="text" 
                                    name="adresse" 
                                    value={formData.adresse} 
                                    onChange={handleChange} 
                                    className="form-control"
                                  />
                                </div>
                                <div className="col-md-12">
                                  <label>Présentation:</label>
                                  <textarea 
                                    name="presentation" 
                                    value={formData.presentation} 
                                    onChange={handleChange} 
                                    rows="3"
                                    className="form-control"
                                  />
                                </div>
                                <div className="col-md-12">
                                  <label>Informations supplémentaires:</label>
                                  <textarea 
                                    name="infosSupplementaires" 
                                    value={formData.infosSupplementaires} 
                                    onChange={handleChange} 
                                    rows="3"
                                    className="form-control"
                                  />
                                </div>
                              </div>
                              
                              <fieldset>
                                <legend>Changement de mot de passe</legend>
                                <div className="row">
                                  <div className="col-md-12">
                                    <label>Mot de passe actuel :</label>
                                    <input 
                                      type="password" 
                                      name="currentPassword" 
                                      value={formData.currentPassword} 
                                      onChange={handleChange} 
                                      className="form-control"
                                    />
                                    <label>Nouveau mot de passe :</label>
                                    <input 
                                      type="password" 
                                      name="newPassword" 
                                      value={formData.newPassword} 
                                      onChange={handleChange} 
                                      className="form-control"
                                    />
                                    <label>Confirmer le nouveau mot de passe :</label>
                                    <input 
                                      type="password" 
                                      name="confirmNewPassword" 
                                      value={formData.confirmNewPassword} 
                                      onChange={handleChange} 
                                      className="form-control"
                                    />
                                  </div>
                                </div>
                              </fieldset>
                              
                              {error && (
                                <div className="alert alert-danger" role="alert">
                                  {error}
                                </div>
                              )}
                              
                              {success && (
                                <div className="alert alert-success" role="alert">
                                  {success}
                                </div>
                              )}
                              
                              <div className="btn-wrapper">
                                <button type="submit" className="btn theme-btn-1 btn-effect-1 text-uppercase">
                                  Enregistrer les modifications
                                </button>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                      
                      {/* My Properties */}
                      <div className="tab-pane fade" id="ltn_tab_1_5">
                        <div className="ltn__myaccount-tab-content-inner">
                          <div className="ltn__my-properties-table table-responsive">
                            <table className="table">
                              <thead>
                                <tr>
                                  <th scope="col">Image</th>
                                  <th scope="col">Propriété</th>
                                  <th scope="col">Statut</th>
                                  <th scope="col">Date</th>
                                  <th scope="col">Actions</th>
                                </tr>
                              </thead>
                              <tbody>
                                {properties && properties.length > 0 ? (
                                  properties.map((property) => (
                                    <tr key={property._id}>
                                      <td className="ltn__my-properties-img">
                                        <Link to={`/product-details/${property._id}`}>
                                          <img
                                            src={property.images && property.images.length > 0 ? property.images[0] : "assets/img/product-3/default.jpg"}
                                            alt="Property"
                                            style={{width: '80px', height: '60px', objectFit: 'cover'}}
                                          />
                                        </Link>
                                      </td>
                                      <td>
                                        <div className="ltn__my-properties-info">
                                          <h6 className="mb-10">
                                            <Link to={`/product-details/${property._id}`}>{property.title}</Link>
                                          </h6>
                                          <small>
                                            <i className="icon-placeholder" /> {property.address}, {property.city}
                                          </small>
                                        </div>
                                      </td>
                                      <td>
                                        {property.approvalStatus === 'approved' ? (
                                          <span style={{color: 'green', fontWeight: 'bold'}}>✅ Approuvé</span>
                                        ) : (
                                          <span style={{color: 'orange', fontWeight: 'bold'}}>⏳ En attente</span>
                                        )}
                                      </td>
                                      <td>{new Date(property.createdAt).toLocaleDateString()}</td>
                                      <td>
  {/* Icon Modifier */}
 <i
  className="fa-solid fa-pen-to-square"
  title="Modifier"
  style={{ color: "#0d6efd", fontSize: "18px", cursor: "pointer" }}
  onClick={() => {
    setCurrentProperty(property); // sauvegarde la propriété à éditer
    setShowEditModal(true);       // ouvre le modal
  }}
></i>

  {/* Icon Supprimer */}
  <i
    className="fa-solid fa-trash-can"
    title="Supprimer"
    style={{ color: "red", fontSize: "18px", cursor: "pointer" }}
    onClick={() => handleDelete(property._id)}
  ></i>
</td>
                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td colSpan="5" style={{ textAlign: 'center', padding: '20px' }}>
                                      Aucune propriété trouvée.
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                      
                      {/* FORMULAIRE D'AJOUT DE PROPRIÉTÉ CORRIGÉ */}
                      <div className="tab-pane fade" id="ltn_tab_1_6">
                        <div className="ltn__myaccount-tab-content-inner">
                          <div className="property-form-container">
                            <div className="form-header mb-4">
                              <h3 className="form-title">
                                <i className="fas fa-plus-circle me-2"></i>
                                Ajouter une propriété
                              </h3>
                              <p className="text-muted">
                                Remplissez tous les champs pour ajouter un nouveau bien. 
                                <span style={{color: 'orange', marginLeft: '10px'}}>
                                  Votre propriété sera en attente d'approbation
                                </span>
                              </p>
                              {/* Dans votre formulaire, juste après le titre */}
{error && (
  <div className="alert alert-danger alert-dismissible fade show" role="alert" style={{
    backgroundColor: '#f8d7da',
    borderColor: '#f5c6cb',
    color: '#721c24',
    padding: '15px 20px',
    borderRadius: '8px',
    marginBottom: '20px',
    display: 'flex',
    alignItems: 'center',
    gap: '10px'
  }}>
    <i className="fas fa-exclamation-circle" style={{ fontSize: '20px' }}></i>
    <div style={{ flex: 1 }}>
      <strong>Erreur :</strong> {error}
    </div>
    <button 
      type="button" 
      className="btn-close" 
      onClick={() => setError("")}
      style={{
        background: 'transparent',
        border: 'none',
        fontSize: '20px',
        cursor: 'pointer',
        color: '#721c24'
      }}
    >
      <i className="fas fa-times"></i>
    </button>
  </div>
)}

{success && (
  <div className="alert alert-success" role="alert" style={{
    backgroundColor: '#d4edda',
    borderColor: '#c3e6cb',
    color: '#155724',
    padding: '15px 20px',
    borderRadius: '8px',
    marginBottom: '20px',
    display: 'flex',
    alignItems: 'center',
    gap: '10px'
  }}>
    <i className="fas fa-check-circle" style={{ fontSize: '20px' }}></i>
    <div style={{ flex: 1 }}>
      <strong>Succès :</strong> {success}
    </div>
    <button 
      type="button" 
      className="btn-close" 
      onClick={() => setSuccess("")}
      style={{
        background: 'transparent',
        border: 'none',
        fontSize: '20px',
        cursor: 'pointer',
        color: '#155724'
      }}
    >
      <i className="fas fa-times"></i>
    </button>
  </div>
)}
                            </div>

                            <form onSubmit={handleAddProperty} className="property-form">
                              {/* Section 1: Informations de base */}
                              <div className="form-section">
                                <div className="section-header">
                                  <h4><i className="fas fa-info-circle me-2"></i>Informations générales</h4>
                                </div>
                                <div className="row">
                                  <div className="col-md-6 mb-4">
                                    <div className="form-group">
                                      <label className="form-label">
                                        Titre de l'annonce <span className="text-danger">*</span>
                                      </label>
                                      <input 
                                        type="text" 
                                        name="title" 
                                        value={propertyFormData.title} 
                                        onChange={handlePropertyChange} 
                                        required 
                                        className="form-control"
                                        placeholder="Ex: Magnifique villa avec piscine"
                                      />
                                    </div>
                                  </div>
                                  
                                  <div className="col-md-6 mb-4">
                                    <div className="form-group">
                                      <label className="form-label">
                                        Prix (FCFA) <span className="text-danger">*</span>
                                      </label>
                                      <input 
                                        type="number" 
                                        name="price" 
                                        value={propertyFormData.price} 
                                        onChange={handlePropertyChange} 
                                        required 
                                        className="form-control"
                                        placeholder="25000000"
                                      />
                                    </div>
                                  </div>

                                  <div className="col-md-6 mb-4">
                                    <div className="form-group">
                                      <label className="form-label">Type de transaction</label>
                                      <select 
                                        name="transactionType" 
                                        value={propertyFormData.transactionType} 
                                        onChange={handlePropertyChange} 
                                        className="form-select"
                                      >
                                        <option value="sale">À vendre</option>
                                        <option value="rent">À louer</option>
                                      </select>
                                    </div>
                                  </div>
                                  
                                  <div className="col-md-6 mb-4">
                                    <div className="form-group">
                                      <label className="form-label">Type de bien</label>
                                      <select 
                                        name="productType" 
                                        value={propertyFormData.productType} 
                                        onChange={handlePropertyChange} 
                                        className="form-select"
                                      >
                                        <option value="appartement">Appartement</option>
                                        <option value="bureau_commerce">Bureau / Commerce</option>
                                        <option value="hotel_restaurant">Hôtel / Restaurant</option>
                                        <option value="immeuble">Immeuble</option>
                                        <option value="studio_chambre">Studio / Chambre</option>
                                        <option value="villa_maison">Villa / Maison</option>
                                        <option value="terrain">Terrain</option>
                                      </select>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {/* Section 2: Localisation */}
                              <div className="form-section">
                                <div className="section-header">
                                  <h4><i className="fas fa-map-marker-alt me-2"></i>Localisation</h4>
                                </div>
                                <div className="row">
                                  <div className="col-md-6 mb-4">
                                    <div className="form-group">
                                      <label className="form-label">Adresse <span className="text-danger">*</span></label>
                                      <input 
                                        type="text" 
                                        name="address" 
                                        value={propertyFormData.address} 
                                        onChange={handlePropertyChange} 
                                        required 
                                        className="form-control"
                                        placeholder="Rue, quartier, numéro"
                                      />
                                    </div>
                                  </div>
                                  
                                  <div className="col-md-6 mb-4">
                                    <div className="form-group">
                                      <label className="form-label">Ville <span className="text-danger">*</span></label>
                                      <input 
                                        type="text" 
                                        name="city" 
                                        value={propertyFormData.city} 
                                        onChange={handlePropertyChange} 
                                        required 
                                        className="form-control"
                                        placeholder="Ex: Dakar, Thiès"
                                      />
                                    </div>
                                  </div>
                                  
                                  <div className="col-md-6 mb-4">
                                    <div className="form-group">
                                      <label className="form-label">Catégorie</label>
                                      <select 
                                        name="propertyCategory" 
                                        value={propertyFormData.propertyCategory} 
                                        onChange={handlePropertyChange} 
                                        className="form-select"
                                      >
                                        <option value="residential">Résidentiel</option>
                                        <option value="commercial">Commercial</option>
                                      </select>
                                    </div>
                                  </div>
                                  
                                  <div className="col-md-6 mb-4">
                                    <div className="form-group">
                                      <label className="form-label">Statut CODOU <span className="text-danger">*</span></label>
                                      <select 
                                        name="coduStatus" 
                                        value={propertyFormData.coduStatus} 
                                        onChange={handlePropertyChange} 
                                        required 
                                        className="form-select"
                                      >
                                        <option value="">Sélectionnez</option>
                                        <option value="codu">CODU</option>
                                        <option value="noncodu">Non CODU</option>
                                      </select>
                                    </div>
                                  </div>

                                  <div className="col-md-6 mb-4">
                                    <div className="form-group">
                                      <label className="form-label">Latitude</label>
                                      <input 
                                        type="number" 
                                        step="any" 
                                        name="latitude" 
                                        value={propertyFormData.coordinates.latitude} 
                                        onChange={handleCoordinatesChange} 
                                        className="form-control"
                                        placeholder="14.7167"
                                      />
                                    </div>
                                  </div>
                                  
                                  <div className="col-md-6 mb-4">
                                    <div className="form-group">
                                      <label className="form-label">Longitude</label>
                                      <input 
                                        type="number" 
                                        step="any" 
                                        name="longitude" 
                                        value={propertyFormData.coordinates.longitude} 
                                        onChange={handleCoordinatesChange} 
                                        className="form-control"
                                        placeholder="-17.4677"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {/* Section 3: Caractéristiques */}
                              <div className="form-section">
                                <div className="section-header">
                                  <h4><i className="fas fa-home me-2"></i>Caractéristiques</h4>
                                </div>
                                <div className="row">
                                  <div className="col-md-4 mb-4">
                                    <div className="form-group">
                                      <label className="form-label">Chambres</label>
                                      <input 
                                        type="number" 
                                        name="bedrooms" 
                                        value={propertyFormData.features.bedrooms} 
                                        onChange={(e) => handleNestedChange(e, "features")} 
                                        className="form-control"
                                        min="0"
                                      />
                                    </div>
                                  </div>
                                  
                                  <div className="col-md-4 mb-4">
                                    <div className="form-group">
                                      <label className="form-label">Salles de bain</label>
                                      <input 
                                        type="number" 
                                        name="bathrooms" 
                                        value={propertyFormData.features.bathrooms} 
                                        onChange={(e) => handleNestedChange(e, "features")} 
                                        className="form-control"
                                        min="0"
                                      />
                                    </div>
                                  </div>
                                  
                                  <div className="col-md-4 mb-4">
                                    <div className="form-group">
                                      <label className="form-label">Surface (m²)</label>
                                      <input 
                                        type="number" 
                                        name="area" 
                                        value={propertyFormData.features.area} 
                                        onChange={(e) => handleNestedChange(e, "features")} 
                                        className="form-control"
                                        min="0"
                                        placeholder="Surface en m²"
                                      />
                                    </div>
                                  </div>

                                  <div className="col-md-4 mb-4">
                                    <div className="form-check">
                                      <input 
                                        type="checkbox" 
                                        className="form-check-input" 
                                        id="hasPool"
                                        name="hasPool" 
                                        checked={propertyFormData.features.hasPool} 
                                        onChange={(e) => setPropertyFormData({ 
                                          ...propertyFormData, 
                                          features: { ...propertyFormData.features, hasPool: e.target.checked } 
                                        })}
                                      />
                                      <label className="form-check-label" htmlFor="hasPool">
                                        Piscine
                                      </label>
                                    </div>
                                  </div>

                                  <div className="col-md-4 mb-4">
                                    <div className="form-check">
                                      <input 
                                        type="checkbox" 
                                        className="form-check-input" 
                                        id="isNewConstruction"
                                        checked={propertyFormData.buildingDetails.isNewConstruction} 
                                        onChange={(e) => setPropertyFormData({ 
                                          ...propertyFormData, 
                                          buildingDetails: { ...propertyFormData.buildingDetails, isNewConstruction: e.target.checked } 
                                        })}
                                      />
                                      <label className="form-check-label" htmlFor="isNewConstruction">
                                        Nouvelle construction
                                      </label>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {/* Section 4: Description */}
                              <div className="form-section">
                                <div className="section-header">
                                  <h4><i className="fas fa-align-left me-2"></i>Description</h4>
                                </div>
                                <div className="row">
                                  <div className="col-12">
                                    <div className="form-group">
                                      <textarea 
                                        name="description" 
                                        value={propertyFormData.description} 
                                        onChange={handlePropertyChange} 
                                        className="form-control" 
                                        rows="6"
                                        placeholder="Décrivez votre bien en détail"
                                      ></textarea>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {/* Section 5: Images */}
                              {/* Section 5: Images */}
                                {/* Section des images avec gestion d'erreur */}
<div className="form-section">
  <div className="section-header">
    <h4><i className="fas fa-images me-2"></i>Photos</h4>
  </div>
  <div className="row">
    <div className="col-12">
      <div className="form-group">
        <label className="form-label">Ajouter des images :</label>
        
        <input 
          type="file" 
          accept="image/*" 
          onChange={handleLocalUpload}
          className="form-control mb-3"
        />

        {/* Affichage des images avec gestion d'erreur */}
        {propertyFormData.images.length > 0 && (
          <div className="image-preview-grid mt-4">
            <div className="row">
              {propertyFormData.images.map((imgUrl, idx) => (
                <div key={idx} className="col-md-3 col-sm-4 col-6 mb-3">
                  <div className="image-preview-card" style={{position: 'relative'}}>
                    <img 
                      src={imgUrl} 
                      alt={`img-${idx}`} 
                      className="img-fluid" 
                      style={{
                        width: '100%', 
                        height: '120px', 
                        objectFit: 'cover',
                        border: '1px solid #ddd',
                        borderRadius: '4px'
                      }}
                      onError={(e) => {
                        console.log(`Erreur de chargement pour: ${imgUrl}`);
                        e.target.onerror = null; // Évite la boucle infinie
                        e.target.src = 'https://via.placeholder.com/150?text=Image+non+disponible';
                      }}
                    />
                    <button 
                      type="button" 
                      onClick={() => {
                        setPropertyFormData(prev => ({
                          ...prev,
                          images: prev.images.filter((_, i) => i !== idx)
                        }));
                      }}
                      style={{
                        position: 'absolute',
                        top: '5px',
                        right: '5px',
                        background: 'red',
                        color: 'white',
                        border: 'none',
                        borderRadius: '50%',
                        width: '25px',
                        height: '25px',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}
                    >
                      ×
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
        
        {/* Message si aucune image */}
        {propertyFormData.images.length === 0 && (
          <p className="text-muted mt-2">Aucune image uploadée</p>
        )}
      </div>
    </div>
  </div>
</div>

                              {/* Boutons */}
                              <div className="form-actions mt-4">
                                <button 
                                  type="submit" 
                                  className="btn btn-primary"
                                  disabled={isLoading}
                                  style={{
                                    backgroundColor: "#975D23",
                                    color: "white",
                                    padding: "10px 30px",
                                    border: "none",
                                    borderRadius: "5px",
                                    cursor: isLoading ? "not-allowed" : "pointer",
                                    marginRight: "10px",
                                    opacity: isLoading ? 0.7 : 1
                                  }}
                                >
                                  {isLoading ? "En cours..." : "Ajouter la propriété"}

                                  
                                </button>
                                <br/>
                                
                                <button 
                                  type="button" 
                                  className="btn btn-secondary"
                                  onClick={resetPropertyForm}
                                  style={{
                                    padding: "10px 30px",
                                    borderRadius: "5px"
                                  }}
                                >
                                  Réinitialiser
                                </button>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyAccount;